export const manifest = {
  screens: {
    scr_32krgk: { name: "Global Command Center", route: "/" },
  },
}
